<template>
  <div class="suggested-spaces">
    <template v-if="listings && listings[0]">
      <SpaceCard v-for="space in listings[0].node.listings.edges" v-bind:key="space.node.id" :space="space.node" :linkType="'routerLink'" :user="user"></SpaceCard>   
    </template>
  </div>
</template>

<script>
    import SpaceCard from "../../components/search/SpaceCard"
    import axios from 'axios'
    import gql from 'graphql-tag'

    export default {
        name: 'SuggestedSpaces',
        data: () => ({
          user: null,
          listings: null
        }),
        props: {
        },
        components: {
            SpaceCard
        },
        mounted () {
            this.getUser()
            this.listingGroupsQuery()
        },
        methods: {
        getUser () {
          var self = this
          axios
          .get('/api/searches/get_user')
          .then(response => {
              if (response.data.response == true) {
                self.user = response.data
              }
          })
        },
        async listingGroupsQuery () {
          this.isLoading = true
          var self = this
          const response = await this.$apollo.query({
            query: gql`
            query getListingGroups ($slug: String!) {
              listingGroups (first: 1, slug: $slug) {
                edges {
                  node {
                    id
                    name
                    slug
                    title
                    subtitle
                    description
                    hexColour
                    isShoppingCentre
                    address
                    featuredDescription
                    featuredImageUrl
                    iframeEmbed
                    featuredLogoUrl
                    featuredImage2Url
                    featuredImage3Url
                    weight
                    latitude
                    longitude
                    houseRules
                    insuranceAndSafety
                    additionalNotes
                    cancellationPolicy
                    footfall
                    mapClusterLogoUrl
                    createdAt
                    updatedAt
                    listings (first: 4) {
                      edges {
                        node {
                          id
                          title
                          address
                          price
                          currentUse
                          description
                          status
                          houseRules
                          insuranceAndSafety
                          additionalNotes
                          county
                          latitude
                          longitude
                          liabilityInsurance
                          cancellationPolicy
                          capacity
                          slug
                          image1Url
                          image2Url
                          image3Url
                          createdAt
                          updatedAt
                          spaceSize
                          spaceSizeType
                          categoriesListings {
                            edges {
                              node {
                                listingId
                                categoryId
                                categoryName
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`,
            variables: {
              slug: 'la-dehesa'
            }
          }).then((response) => {
            self.listings = response.data.listingGroups.edges
          })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../scss/global/includes";

.suggested-spaces {
    gap: 16px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    @include breakpoint(tablet) {
      grid-template-columns: repeat(1, 1fr);
    }
}



</style>
